import { Link } from 'react-router';
import { useT } from '../i18n';
import { useSensors } from '../lib/sensors';
import { lidarRangeOf, useLidar, type LidarRange } from '../lib/lidar';
import { useStoredState } from '../lib/hooks';
import { useLive } from '../live/store';
import { Radar } from './Radar';

/**
 * Mini proximity radar (camera corner / Fleet tile). Hidden when the robot reports no sensors at all. `lidar`: also
 * watch the robot's live lidar (§27) and draw it — only where asked (the camera view, not every Fleet tile).
 */
export function SensorMini({ serial, size, className, style, lidar = false }: { serial: string; size: number; className?: string; style?: React.CSSProperties; lidar?: boolean }) {
  const t = useT();
  const v = useSensors(serial);
  const l = useLidar(serial, lidar);
  const [range] = useStoredState<LidarRange>('cruzr.lidarRange', 4);
  const guard = useLive((s) => s.robots[serial]?.status?.guard ?? null);
  if (!v.has && !l) return null;
  return (
    <Link to={`/robots/${encodeURIComponent(serial)}/sensors`} className={`sensor-mini ${className ?? ''}`} style={style} aria-label={t('sens.openSensors')} title={t('sens.openSensors')} onClick={(e) => e.stopPropagation()}>
      <Radar view={v} size={size} variant="mini" lidar={l} lidarRange={lidarRangeOf(range, l)} guard={guard} />
    </Link>
  );
}
